<div class="h-full bg-off-white rounded-12px">
	<div class="relative">
		<main class="p-24px w-full rounded-24px card">
			<div class="{{ isFlipped ? 'content' : 'content content1' }}">
				<div class="front">
					<div class="flex justify-between items-center mb-16px">
						<div>
							<h1 class="mb-0 mt-5 inline-block">
								{{ 'PAYOUT.PAYOUTS' | translate }}
							</h1>
							<div
								*ngIf="pendingCount != 0"
								class="bg-gradient mx-2 text-[10px] text-off-white rounded-full w-[20px] h-[20px] text-center inline-block"
							>
								<span>{{ pendingCount }}</span>
							</div>
						</div>

						<app-search-filter
							(toggleFilter)="sidenav.toggle()"
							[showSearch]="false"
							[filterCount]="filterCount"
							(resetFilter)="filter.resetFilter()"
						></app-search-filter>
					</div>
					<div
						*ngFor="let payout of spPayouts"
						(click)="
							isFlipped = !isFlipped;
							toggle();
							flipChange(payout.id, payout.payoutStatus);
							getDetails(payout.id)
						"
						class="py-12px pl-16px pr-24px flex rounded-6px cursor-pointer bg-[#F5F5F5] justify-between items-center border-b-[1px] border-[#D9DBE9]"
					>
						<div class="flex">
							<img
								class="mr-16px {{
									payout?.payoutMethod?.id == 1 ? 'h-[24px] my-auto' : ''
								}} "
								src="assets/images/{{
									payout?.payoutMethod?.id == 1
										? 'bank'
										: payout?.payoutMethod?.id == 2
										? 'Fawri'
										: 'instapay'
								}}.{{ payout?.payoutMethod?.id == 1 ? 'png' : 'svg' }}"
								alt=""
							/>
							<div>
								<h1 class="text-dark-grey text-font-16 mb-0">
									#{{ payout?.id }}
								</h1>
								<p class="text-medium-gray text-font-14 mb-0">
									{{
										payout?.transactionDate
											| date : 'dd/MM/yyyy , hh:mm a' : 'UTC'
									}}
								</p>
							</div>
						</div>
						<div>
							<div
								class="{{
									payout?.payoutStatus == 1 ? 'bg-[#FBE7E5]' : 'bg-[#E2F5EE]'
								}} py-[2px] px-[6px] rounded-[50px] mb-6px inline-block"
							>
								<div
									class="rounded-full w-[5px] h-[5px] {{
										payout?.payoutStatus == 1 ? 'bg-salon' : 'bg-success-green'
									}} inline-block m-[2px]"
								></div>
								<p
									class="inline-block {{
										payout?.payoutStatus == 1
											? 'text-salon'
											: 'text-success-green'
									}} m-0 max-mobile:text-font-mobile-small"
								>
									{{
										payout?.payoutStatus == 1
											? ('PAYOUT.PAYOUT_LIST.PENDING' | translate)
											: ('PAYOUT.PAYOUT_LIST.PAYED' | translate)
									}}
								</p>
							</div>
							<h1
								class="text-font-14 text-dark-grey font-DIN-bold font-bold mb-0"
							>
								{{
									translate.currentLang == 'en'
										? payout?.currency?.name?.en
										: payout?.currency?.name?.ar
								}}
								+{{ payout?.requiredAmount }}
								<span class="mx-2">></span>
							</h1>
						</div>
					</div>
					<app-no-data-found *ngIf="!spPayouts.length"></app-no-data-found>
					<div class="mt-8 py-5 max-mobile:overflow-auto">
						<app-pagination
							[totalCount]="totalCount"
							[pageNumber]="spPayoutFilter.paging.pageNumber"
							[pageCount]="spPayoutFilter.paging.pageSize"
							(currentPage)="
								pagingChanged($event, spPayoutFilter.paging.pageSize)
							"
							(itemsCountPerPage)="pagingChanged(1, $event)"
							[smallSize]="true"
						></app-pagination>
					</div>
				</div>
				<div class="back">
					<app-sp-payout-details
						[viewMode]="queryParamsData?.status == 2 ? true : false"
						(flipped)="
							isFlipped = $event;
							flipped.emit($event);
							$event == true ? getSPPayouts() : '';
							$event == true ? getSPPendingCount() : ''
						"
						[payoutSpDetails]="payoutSpDetails"
					></app-sp-payout-details>
				</div>
			</div>
		</main>
	</div>
</div>
<ng-container>
	<mat-sidenav-container [hasBackdrop]="true" class="z-20">
		<mat-sidenav
			position="end"
			#sidenav
			mode="side"
			opened
			class="max-w-[428px] bg-white text-dark-grey p-12px min-h-screen"
			[fixedInViewport]="true"
			[fixedTopGap]="0"
			[disableClose]="false"
			[fixedBottomGap]="0"
			[disableClose]="false"
			[opened]="false"
		>
			<header class="tw-p-4 p-12px">
				<div class="rtl:text-left ltr:text-right">
					<button (click)="sidenav.toggle()">
						<img src="./assets/images/close-square.svg" alt="" />
					</button>
				</div>
			</header>
			<app-sp-payout-list-filter
				#filter
				[filterData]="spPayoutFilter"
				(emitFilter)="getSPPayouts($event); sidenav.toggle()"
				(emitfilterCount)="filterCount = $event"
			></app-sp-payout-list-filter>
		</mat-sidenav>
	</mat-sidenav-container>
</ng-container>
